import { render, staticRenderFns } from "./sysStudentAdmission.vue?vue&type=template&id=29f7f666&"
import script from "./sysStudentAdmission.vue?vue&type=script&lang=js&"
export * from "./sysStudentAdmission.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentAdmission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports